<div class="bk-page gd">
  <header class="bk-page__head">
    <div class="bk-page__intro">
      <app-back-button class="gd__back" label="Back" (back)="goBack()" />
      <p class="bk-eyebrow">Organization</p>
      @if (loading && !organizationDetail) {
        <span class="bk-skel gd__skel-title" aria-hidden="true"></span>
        <span class="bk-skel gd__skel-line" aria-hidden="true"></span>
        <span class="bk-sr-only">Loading the organization</span>
      } @else {
        <h1 class="bk-page__title">{{ loadError ? 'Organization did not load' : name }}</h1>
        @if (!loadError) {
          <p class="bk-page__sub" [class.gd__sub-empty]="!description">{{ description || 'No description' }}</p>
        }
      }
    </div>

    @if (organizationDetail) {
      <div class="bk-page__actions">
        <ng-container *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="openEdit()">
            <span class="bk-sym" aria-hidden="true">edit</span>
            Edit
          </button>
          <button type="button" class="bk-btn bk-btn--ghost" (click)="openShowAddAnotherContact()">
            <span class="bk-sym" aria-hidden="true">person_add</span>
            Add contacts
          </button>
        </ng-container>
        <button
          *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
          type="button"
          class="bk-btn bk-btn--primary"
          (click)="messageGroup()"
        >
          <span class="bk-sym" aria-hidden="true">send</span>
          Message this organization
        </button>
      </div>
    }
  </header>

  @if (loadError) {
    <section class="bk-panel gd__error" role="alert">
      <h2 class="bk-heading gd__error-title">We could not open this organization</h2>
      <p class="gd__error-text">{{ loadError }}</p>
      <div class="gd__error-actions">
        <button type="button" class="bk-btn bk-btn--primary" (click)="loadOrganization()">Load again</button>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="goBack()">Go back</button>
      </div>
    </section>
  } @else if (organizationDetail) {
    <div class="gd__overview">
      <div class="bk-stats gd__stats">
        <div class="bk-stat">
          @if (countError) {
            <div class="bk-stat__value" title="The count did not load. Reload the page to try again." aria-hidden="true">—</div>
            <span class="bk-sr-only">The count did not load</span>
          } @else if (contactsCount === null) {
            <span class="bk-skel gd__stat-skel" aria-hidden="true"></span>
          } @else {
            <div class="bk-stat__value">{{ formatCount(contactsCount) }}</div>
          }
          <div class="bk-stat__label">Members</div>
        </div>
        @if (reach) {
          <div class="bk-stat">
            <div class="bk-stat__value">{{ formatCount(reach.withNumber) }}</div>
            <div class="bk-stat__label">Have a phone number</div>
          </div>
          <div class="bk-stat" [attr.data-tone]="reach.withoutNumber ? 'bad' : null">
            <div class="bk-stat__value">{{ formatCount(reach.withoutNumber) }}</div>
            <div class="bk-stat__label">No phone number</div>
            @if (reach.withoutNumber) {
              <div class="gd__stat-hint">Messages to this organization skip them.</div>
            }
          </div>
        }
      </div>

      <div class="gd__panels">
        <section class="bk-panel gd__panel" aria-labelledby="org-facts-title">
          <h2 class="bk-section-title" id="org-facts-title">Details</h2>
          <dl class="bk-kv">
            <dt>Industry</dt>
            <dd>{{ industry }}</dd>
            <dt>Location</dt>
            <dd>{{ place }}</dd>
            @if (organizationDetail.emailAddress) {
              <dt>Email</dt>
              <dd>{{ organizationDetail.emailAddress }}</dd>
            }
            @if (organizationDetail.primaryContactNumber) {
              <dt>Phone</dt>
              <dd>{{ organizationDetail.primaryContactNumber }}</dd>
            }
            <dt>Created</dt>
            <dd>{{ created }}</dd>
            <dt>Updated</dt>
            <dd>{{ updated }}</dd>
          </dl>
        </section>
      </div>
    </div>

    <section class="gd__members" aria-labelledby="org-members-title">
      <div class="gd__members-head">
        <h2 class="bk-section-title" id="org-members-title">Members</h2>
      </div>
      <group-contacts-table
        groupType="organization"
        [groupDetails]="organizationDetail"
        (updateSelectedContacts)="updateSelectedContacts($event)"
        (action)="handleAction($event)"
        (removeContact)="removeOne($event)"
        (membersChanged)="onMembersChanged()"
      />
    </section>
  }
</div>

<!-- MODALS -->
@if (showAddAnotherContact) {
  <assign-contacts-to-group
    [open]="true"
    (close)="closeShowAddAnotherContact()"
    [title]="'Add contacts to ' + name"
    (assignContacts)="handleAssignContactsToOrganization($event)"
    [isLoading]="addingContactsToOrganization"
  />
}

<edit-organization-form [show]="showEditModal" [organization]="organizationDetail" (closeModal)="closeEdit()" />

<app-prompt-card
  [title]="removeTitle"
  [buttonText]="removeButton"
  [openModal]="showRemoveContactsPrompt"
  (onClose)="closeRemoveContactsPrompt()"
  (onButtonClick)="removeSelectedContactsFromOrganization()"
  [loading]="removing"
>
  <p class="gd__prompt">They leave this organization and stay in your contact list.</p>
</app-prompt-card>
